<template>
  <div class="flx produce_on_page">
    <span><slot name="title">Товаров на странице:</slot></span>
    <span class="show_produce" :class="{ active: item.active }"  v-for="item in values" :key="item.value" @click="changeActive(item.value)">{{ item.value }}</span>
  </div>
</template>

<script>
export default {
  name: 'ItemsPerPage',
  props: {
    value: {
      type: Number,
      default: 20
    },
    items: {
      type: Array,
      default: () => {
        return [20, 40, 60]
      }
    }
  },
  computed: {
    values () {
      const values = []
      for (let i = 0; i < this.items.length; i++) {
        values.push({
          value: this.items[i],
          active: this.items[i] === this.value
        })
      }
      return values
    }
  },
  methods: {
    changeActive (value) {
      this.$emit('update:value', value)
    }
  }
}
</script>

<style scoped>

</style>
